<template>
  <div>
    <motor-life-cycle v-if="appID === constAppID.MOTOR" @salesOpportunity="$emit('salesOpportunity')" :query="query"></motor-life-cycle>
    <cargo-life-cycle v-else-if="appID === constAppID.CARGO" @salesOpportunity="$emit('salesOpportunity')" :query="query"></cargo-life-cycle>
    <fire-life-cycle v-else-if="appID === constAppID.FIRE" @salesOpportunity="$emit('salesOpportunity')" :query="query"></fire-life-cycle>
    <maid-life-cycle v-else-if="appID === constAppID.MAID" @salesOpportunity="$emit('salesOpportunity')" :query="query"></maid-life-cycle>
    <travel-life-cycle v-else-if="appID === constAppID.TRAVEL" @salesOpportunity="$emit('salesOpportunity')" :query="query"></travel-life-cycle>
    <package-life-cycle v-else-if="appID === constAppID.PACKAGE" @salesOpportunity="$emit('salesOpportunity')" :query="query"></package-life-cycle>
    <p-a-life-cycle v-else-if="appID === constAppID.PA" @salesOpportunity="$emit('salesOpportunity')" :query="query"></p-a-life-cycle>
  </div>
</template>

<script>
import MotorLifeCycle from './motor/quotation/MotorLifeCycle'
import CargoLifeCycle from './cargo/quotation/CargoLifeCycle'
import FireLifeCycle from './fire/quotation/FireLifeCycle'
import MaidLifeCycle from './maid/quotation/MaidLifeCycle'
import TravelLifeCycle from './travel/quotation/TravelLifeCycle'
import PackageLifeCycle from './package/quotation/PackageLifeCycle'
import PALifeCycle from './pa/quotation/PALifeCycle'
import { appID } from '@/const/underwriting'

export default {
  data() {
    return {
      steps: 1
    }
  },
  computed: {
    appID() {
      return this.$store.state.agency.quotation.commonForm.appID
    },
    constAppID() {
      return appID
    }
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MotorLifeCycle,
    CargoLifeCycle,
    FireLifeCycle,
    MaidLifeCycle,
    TravelLifeCycle,
    PackageLifeCycle,
    PALifeCycle
  }
}
</script>

<style lang="scss">
// Overwrite timeline content (default will hide content after steps passed)
.policyLifeCycle {
  &.v-stepper {
    box-shadow: none;
    .v-stepper__label {
      display: inline-block;
    }
    .v-stepper__content {
      display: block !important;
      padding: 0 16px 16px 16px;
      span {
        padding-left: 10px;
      }
      .v-stepper__wrapper {
        height: auto !important;
      }
    }
  }
}
</style>
